import ActionText from '../../core/ActionText';
import withGS from '../../core/withGShoc';
import { Typography } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';
import { globalStyles as styles } from '../../core/style/gstheme';
import DataDownload from '../../core/DataDownload';
import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';

class ConceptExport extends React.Component {

    render() {

        const { id, graph, skosXL, classes, data } = this.props;

        if (data._notAvailable) return <ActionText offset="30px">Export is not available.</ActionText>;

        return (
            <div>
                <Typography paragraph className={classes.mainHeading} style={{ marginTop: 10 }}>Export</Typography>
                <Grid container spacing={2}>
                    {data.narrower && data.narrower.length > 0 &&
                        <Grid item xs={12} md={6}>
                            <DataDownload
                                dataTest="concept-hierarchy-download"
                                fullHeight
                                title="Concept Hierarchy"
                                skosXLoption={skosXL}
                                graph={graph}
                                resource={id}
                                exportName="concepthierarchyexport"
                                message="Includes data for the concept and all narrower concepts." />
                        </Grid>
                    }
                    <Grid item xs={12} md={6}>
                        <DataDownload
                            dataTest="concept-download"
                            fullHeight
                            title="Concept"
                            skosXLoption={skosXL}
                            graph={graph}
                            resource={id}
                            exportName="conceptexport"
                            message="Includes data for the concept only." />
                    </Grid>
                </Grid>
            </div>
        );
    }
}

ConceptExport.defaultProps = {
    skosXL: false
};

ConceptExport.propTypes = {
    classes: PropTypes.object.isRequired,
    id: PropTypes.string.isRequired,
    data: PropTypes.object.isRequired,
    graph: PropTypes.string.isRequired,
    skosXL: PropTypes.bool.isRequired
};

export default withStyles(styles)(withGS(ConceptExport, ["ALL"], null, {}, true));